export default "__VITE_ASSET__CThbUF7F__"